import { extractStringValueSet } from './extract-properties';

export class ReportableTarget {

    static readonly SarsCov2V1: string = 'sar-cov2.v1';
    static readonly FluAV1: string = 'flu-a.v1';
    static readonly FluBV1: string = 'flu-b.v1';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
